export const environment = {
    production: false,
    dataApiUrl: 'https://bsa.between.rs/data/api',
    analysisApiUrl: 'https://bsa.between.rs/analysis/api'
};
